<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Order Lelang Baru</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA LELANG</h6>
					<b-form-group label="Emas">
                        <b-form-checkbox-group class="checkbox-group" v-model="input.jenisBarang" name="jenisBarang">
                            <b-form-checkbox v-for="item in optionJenisEmas" v-bind:key="item.id" :value="item.id">
                                {{ item.name }}
                            </b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                    <b-form-group label="Elektronik">
                        <b-form-checkbox-group class="checkbox-group" v-model="input.jenisBarang" name="jenisBarang">
                            <b-form-checkbox v-for="item in optionJenisBarang" v-bind:key="item.id" :value="item.id">
                                {{ item.name }}
                            </b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                    <div class="input-small-wrapper">
                        <b-form-group label="Persiapkan semua barang yang melebihi ">
                            <div class="d-flex align-items-center mb-2">
                                <b-form-input class="mr-2" v-model="input.hariJatuhTempoSkemaBelakang" name="hariJatuhTempoBelakang" type="number" min="1" required></b-form-input>
                                <span class="smallText text-muted">dari jatuh tempo - Untuk Barang Skema 1 (Jasa Dibelakang)</span>
                            </div>
                            <div class="d-flex align-items-center">
                                <b-form-input class="mr-2" v-model="input.hariJatuhTempoSkemaDepan" name="hariJatuhTempoDepan" type="number" min="1" required></b-form-input>
                                <span class="smallText text-muted">dari jatuh tempo - Untuk Barang Skema 2 (Jasa Didepan)</span>
                            </div>
                        </b-form-group>
                        <p class="smallText text-muted mb-0">Bila order lelang dilakukan pada tanggal 15 Januari dan input adalah 15 hari, maka gadai elektronik yang akan diorder lelang adalah yang berjatuh tempo pada tanggal 1 Januari (16 Januari dikurang 15 hari)</p>
                    </div>
                </div>
                <!-- TO DO LELANG ORDER ADDITIONAL DATA -->
                <div class="date-wrapper">
                    <h6 class="form-title">DATE</h6>
                    <div class="my-3">
                <label>
                    Tanggal Planning Set Kirim
                </label>

                <b-form-group class="mb-0" style="max-width: 250px;">
                    <b-form-input type="date" v-model="input.datePlanning" />
                </b-form-group>
            </div>
            <div class="my-3">
                <label>Deadline Penyelesaian Packing dan Pengiriman Drop Off</label>
                <b-form-group class="mb-0" style="max-width: 250px;">
                    <b-form-input type="date" v-model="input.dropoffAt" name="dropoffAt" />
                </b-form-group>
            </div>
            <div class="my-3">
                <label>Tanggal Mulai Penjemputan Lelang</label>
                <b-form-group class="mb-0" style="max-width: 250px;">
                    <b-form-input type="date" v-model="input.shipmentStartedAt" name="shipmentStartedAt" />
                </b-form-group>
            </div>

                </div>
                <div class="detail-data-wrapper">
                    <h6 class="form-title">CABANG</h6>
                    <b-form-group>
                        <b-form-checkbox
                            v-model="checkAllCabang" name="checkAllCabang"
                            :disabled="disabled"
                            @change="toggleAll"
                            >
                            {{ checkAllCabang ? 'Uncheck All' : 'Check All' }}
                        </b-form-checkbox>
                    </b-form-group>
                    <div>
                        <div class="search-wrapper d-flex align-items-center justify-content-between">
                            <b-form-group
                                label="Filter"
                                label-for="filterInput"
                                class="form-inline mb-3"
                            >
                                <b-form-input class="mr-2 ml-2"
                                    v-model="filter" name="filterTable"
                                    type="search"
                                    placeholder="Type to search"
                                >
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <b-table bordered hover show-empty
                            :busy="isBusy"
                            :items="cabangItems" 
                            :fields="fields"
                            :currentPage="currentPage" 
                            :perPage="perPage"
                            :filter="filter"
							:filterIncludedFields="filterOn"
                            @filtered="onFiltered"
                            responsive class="mb-3">
                            <template v-slot:cell(checkCabang)="row">
                                <b-form-checkbox :id="'cb' + row.item.id" v-model="row.item.selected">
                                    {{ row.item.name }}
                                </b-form-checkbox>
                            </template>
                            <template v-slot:empty>
                                Tidak ada data cabang.
                            </template>
                        </b-table>
                        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                            <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                                <b-form-select v-model="input.show" class="customCabangOption" id="showItems" :options="options" @change="onLimitChange">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled />
                                    </template>
                                </b-form-select>
                            </b-input-group>
                            <b-pagination class="mb-0"
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                                aria-controls="my-table"
                                @input="onPageChange"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
                <div class="form-wrapper-btn">
                    <b-button class="mr-2 mt-2" @click="openModalNilaiUnit" name="hitungJumlahUnitBtn" variant="cancelBtn">Hitung Jumlah Unit</b-button>
                    <b-button class="mr-2 mt-2" type="submit" name="orderLelangSubmitBtn" variant="pgiBtn">Kirim</b-button>
                    <b-button
                    class="mt-2"
                    name="requestHitungJumlahUnitBtn"
                    variant="dark"
                    @click="isModalVisible = true"
                >
                    Request Hitung Jumlah Unit
                </b-button>
                </div>
            </b-form>
        </b-card>
        <b-modal
        id="confirm-download-modal"
        v-model="isModalVisible"
        title="Konfirmasi Download"
        @ok="handleConfirm"
        ok-title="Ya, Lanjutkan"
        cancel-title="Batal"
        >
        <p>Apakah Anda yakin ingin request hitung Jumlah Unit <strong>{{ tipeSK }}</strong>?</p>
        </b-modal>
        <ModalConfirm id="modal-confirm-input" title="Confirm Order Lelang Baru" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput Order Lelang ini?" @submit="onSubmit" />
        <b-modal id="modal-jumlah-unit" title="Jumlah Unit" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-2" v-if="isLoadingJumlahUnit">
                <div class="text-center">
                    <b-spinner class="align-middle mb-4"></b-spinner>
                    <p class="mb-0">Sedang menghitung, mohon menunggu...</p>
                </div>
            </div>
            <div class="detail-data-wrapper mb-2" v-else>
                <div v-if="rincian.length != 0">
                    <p>
                        Estimasi jumlah barang yang akan dilelangkan ({{input.jenisBarang.length}} jenis, {{jumlahSelectedCabang}} cabang) 
                        dengan jarak {{input.hariJatuhTempoSkemaBelakang}} / {{input.hariJatuhTempoSkemaDepan}} hari dari jatuh tempo
                    </p>
                    <ul class="list-circle-wrapper">
                        <li v-for="item in rincian"  v-bind:key="item.id">
                            {{ item.nama }} : {{ item.jumlah }} unit - Rp. {{$helper.addThousandSeparator(item.harga)}}
                        </li>
                    </ul>
                    <b-alert class="mt-4 mb-0" variant="primary" show>
                        * Estimasi perhitungan ini berdasarkan jatuh tempo terhitung 
                        <p class="mb-0"><strong> {{$helper.changeDateFormat(tanggalBesok)}}</strong></p>
                    </b-alert>
                </div>
                <p v-else class="mb-0">Tidak ada unit</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeModalJumlahUnit" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>


export default {
    name: 'input-order-lelang',
    data(){
        return{
            isSubmitting: false,
            isBusy: true,
            input: {
                jenisBarang: [],
                hariJatuhTempoSkemaBelakang: 15,
                hariJatuhTempoSkemaDepan: 45,
                show: 10,
                datePlanning: "",
                dropoffAt: "",
                shipmentStartedAt: ""
            },
            fields: [
                { key: "checkCabang", label: "Cabang", tdClass: "checkboxCabang" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 50, text: '50'},
                { value: 100, text: '100'},
                { value: 'All', text: 'Semua'},
            ],
			filter: null,
			filterOn: ["name"],
            checkAllCabang: false,
            disabled: false,
            currentPage: 1,
            perPage: 10,
            rows: null,
            cabangItems: [],
            optionJenisBarang: [],
            optionJenisEmas: [],
            rincian: [],
            isLoadingJumlahUnit: false,
            tanggalBesok: "",
            jumlahSelectedCabang: null,
            isModalVisible: false,
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getJenisElek = this.$axios.get("barang-jenis/elektronik?showAll=true").then(response => {
                this.optionJenisBarang = response.data
			})
			
			let getJenisEmas = this.$axios.get("barang-jenis/emas?showAll=true").then(response => {
                this.optionJenisEmas = response.data
			})

            let getCabang = this.$axios.get("cabang/operational-selection").then(response => {
                this.cabangItems = response.data.map(item => { return { id: item.id, name: item.name, selected: false } })
                this.updateTotalItem()
            })

            Promise.all([getJenisElek, getJenisEmas, getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
                let newDate = new Date();
                newDate.setDate(newDate.getDate() + 1)
                
                var dd = newDate.getDate();
                var mm = newDate.getMonth()+1; //January is 0!
                var yyyy = newDate.getFullYear();
                if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                newDate = yyyy+'-'+mm+'-'+dd;
                this.tanggalBesok = newDate

            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
        },

        onLimitChange(){
            if(this.input.show == 'All'){
                this.perPage = this.rows
            }else{
                this.perPage = this.input.show
                this.onPageChange()
            }
            
        },
        
        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
        },
        
        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()
            let selectedCabang = this.cabangItems.filter(item => item.selected)
            let cabang = []

            //----------------- Append Data Order Lelang -----------------
            
            console.log("tes", this.input.datePlanning);
            
            payload.append("hariMelewatiJatuhTempoSkema1", this.input.hariJatuhTempoSkemaBelakang)
            payload.append("hariMelewatiJatuhTempoSkema2", this.input.hariJatuhTempoSkemaDepan)
            payload.append("scheduleSetSend", this.input.datePlanning)
            payload.append("dropoffAt", this.input.dropoffAt)
            payload.append("shipmentStartedAt", this.input.shipmentStartedAt)

            let y = 0
            for (var x of selectedCabang) {
                cabang[y] = x.id
                y++
            }

            payload.append("cabangIds", cabang)
            
            // Append all checked jenisBarang
            for(let jenisBarang of this.input.jenisBarang) {
                payload.append("jenisBarangIds", jenisBarang)
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("lelang-order/", payload).then(response => {
              
                this.$helper.setFlash(`Order Lelang baru telah berhasil dibuat!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        toggleAll(checked) {
            for(let i=0; i< this.cabangItems.length; i++){
                this.cabangItems[i].selected = checked
            }
        },

        updateTotalItem(){
            this.rows = this.cabangItems.length
            if (this.perPage > this.rows) this.perPage = this.rows
        },

        openModalConfirm(){
            let selectedCabang = this.cabangItems.filter(item => item.selected)
            
            if(this.input.jenisBarang.length == 0){
                this.$helper.toastErr(this, "Mohon memilih minimal 1 jenis barang!")
            }
            else if (selectedCabang.length == 0) {
                this.$helper.toastErr(this, "Mohon memilih minimal 1 cabang!")
            }
            else if (this.input.mulaiPromo > this.input.selesaiPromo) {
                this.$helper.toastErr(this, "Tanggal mulai harus sebelum tanggal selesai!")
            }
            else if (this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal) < 0 || this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal) < 0) {
                this.$helper.toastErr(this, "Minimal dan maksimal harga barang tidak boleh negatif!")
            }
            else if (this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal) > this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal)) {
                this.$helper.toastErr(this, "Minimal harga barang tidak boleh melebihi maksimal harga barang")
            }
            else if (!this.input.dropoffAt) {
                this.$helper.toastErr(this, "Mohon mengisi Deadline Penyelesaian Packing dan Pengiriman Drop Off!")
            }
            else if (!this.input.shipmentStartedAt) {
                this.$helper.toastErr(this, "Mohon mengisi Tanggal Mulai Penjemputan Lelang!")
            }
            else {
                this.$bvModal.show("modal-confirm-input")
            }
        },

        openModalNilaiUnit(){
            let selectedCabang = this.cabangItems.filter(item => item.selected)
            
            if(this.input.jenisBarang.length == 0){
                this.$helper.toastErr(this, "Mohon memilih minimal 1 jenis barang!")
            }
            else if (selectedCabang.length == 0) {
                this.$helper.toastErr(this, "Mohon memilih minimal 1 cabang!")
            }
            else if (this.input.mulaiPromo > this.input.selesaiPromo) {
                this.$helper.toastErr(this, "Tanggal mulai harus sebelum tanggal selesai!")
            }
            else if (this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal) < 0 || this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal) < 0) {
                this.$helper.toastErr(this, "Minimal dan maksimal harga barang tidak boleh negatif!")
            }
            else if (this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal) > this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal)) {
                this.$helper.toastErr(this, "Minimal harga barang tidak boleh melebihi maksimal harga barang")
            }
            else {
                this.$bvModal.show("modal-jumlah-unit")
                this.isLoadingJumlahUnit = true

                //api get jumlah unit
                let payload = new FormData()
                let selectedCabang = this.cabangItems.filter(item => item.selected)
                let cabang = []

                //----------------- Append Data Order Lelang -----------------

                payload.append("hariMelewatiJatuhTempoSkema1", this.input.hariJatuhTempoSkemaBelakang)
                payload.append("hariMelewatiJatuhTempoSkema2", this.input.hariJatuhTempoSkemaDepan)

                let y = 0
                for (var x of selectedCabang) {
                    cabang[y] = x.id
                    y++
                }

                this.jumlahSelectedCabang = selectedCabang.length

                payload.append("cabangIds", cabang)
                
                // Append all checked jenisBarang
                for(let jenisBarang of this.input.jenisBarang) {
                    payload.append("jenisBarangIds", jenisBarang)
                }
                
                this.$axios.post("lelang-order/count", payload).then(response => { 
                    this.jumlahSelectedCabang = selectedCabang.length
                    this.rincian = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoadingJumlahUnit = false
                })
            }
        },
        handleConfirm() {
            let payload = new FormData();
            let selectedCabang = this.cabangItems.filter(item => item.selected);
            let cabang = [];

            payload.append("hariMelewatiJatuhTempoSkema1", this.input.hariJatuhTempoSkemaBelakang);
            payload.append("hariMelewatiJatuhTempoSkema2", this.input.hariJatuhTempoSkemaDepan);
            payload.append("scheduleSetSend", this.input.datePlanning);

            for (let x of selectedCabang) {
                cabang.push(x.id);
            }
            
            payload.append("cabangIds", cabang);

            for (let jenisBarang of this.input.jenisBarang) {
                payload.append("jenisBarangIds", jenisBarang);
            }

            this.isSubmitting = true;

            this.$axios
                .post("lelang-order/request-hitung-lelang/?", payload)
                .then(response => {
                this.$bvToast.toast('Berhasil mengirim request download.', {
                    title: 'Sukses',
                    variant: 'success',
                    solid: true,
                });
                })
                .catch(error => {
                this.$helper.parseError(this, error);
                })
                .finally(() => {
                this.isSubmitting = false;
            });
        },
    },
    created() {
        this.init()
    }
}
</script>